/**
 * Partner job schedule sharing helpers (frontend).
 */

import { openWhatsAppUrl } from "../../../shared/utils/outboundMessaging.js";

/**
 * @param {{ whatsapp?: boolean, email?: boolean }} channels
 * @returns {string[]}
 */
export function getActiveChannelLabels(channels = {}) {
  const labels = [];
  if (channels.whatsapp) labels.push("WhatsApp");
  if (channels.email) labels.push("Email");
  return labels;
}

/**
 * @param {{ whatsapp?: boolean, email?: boolean, missing?: string[] }} channels
 * @returns {string|null}
 */
export function getMissingChannelNotice(channels = {}) {
  const notices = [];

  if (!channels.whatsapp) {
    notices.push("WhatsApp not available (mark phone as WhatsApp-ready in Partners)");
  }

  if (!channels.email) {
    notices.push("Email not available (add partner email in Partners)");
  }

  if (channels.whatsapp && channels.email) {
    return null;
  }

  if (!channels.whatsapp && !channels.email) {
    return "Add a WhatsApp-ready phone or email in Partners → Edit before sharing.";
  }

  return notices.filter(Boolean).join(". ");
}

/**
 * @param {{ url?: string|null }} whatsapp
 */
export function openPartnerJobsWhatsApp(whatsapp) {
  if (!whatsapp?.url) {
    throw new Error("WhatsApp link is not available");
  }
  openWhatsAppUrl(whatsapp.url);
}

/**
 * @param {{ whatsapp?: boolean, email?: boolean }} channelsUsed
 * @returns {string}
 */
export function formatShareSuccessMessage(channelsUsed = {}) {
  const parts = [];
  if (channelsUsed.email) parts.push("Email queued");
  if (channelsUsed.whatsapp) parts.push("WhatsApp opened");
  return parts.join(" · ");
}
